<template>
    <div class="u-card" v-if="(consultation.appointment.appointment_type_id === onlineType && consultation.end_at !== null) ||
    (consultation.appointment.appointment_type_id === clinicType && dateAfter)">

        <card-doctor v-if="access === 'doctor'" :anonymImg="anonymImg" :consultation="consultation"></card-doctor>

        <card v-else :access="access" :consultation="consultation"></card>

        <div class="u-card__data">
            <div class="u-card__meta">
                <div class="u-card__meta-value">
                    <span v-html="startAt"></span>
                </div>
                <div class="u-card__meta-name">
                    <span>Дата приема</span>
                </div>
            </div>
            <div class="u-card__meta" v-if="access !== 'clinic'">
                <div class="u-card__meta-value">
                    <span>{{ consultation.payment ? (consultation.payment.original_price > 0 ? consultation.payment.original_price : (-1) * consultation.payment.original_price)+' ₽' : 'Бесплатно' }}</span>
                </div>
                <div class="u-card__meta-name">
                    <span>Стоимость</span>
                </div>
            </div>
            <card-meta :consultation="consultation"></card-meta>
        </div>
        <div class="u-card__actions" v-if="consultation.appointment.appointment_type_id === onlineType">
             <a v-if="report" :href="`/report/` + consultation.id + `/download`" class="u-card__action r-link button button_secondary">Скачать отчёт</a>
             <button v-else-if="access == 'doctor' || access == 'clinic'" class="u-card__action r-button button button_secondary" @click="$refs.report.click()">Загрузить отчёт</button>
             <button v-else class="u-card__action r-button button button_secondary" disabled>Скачать отчёт</button>
             <input v-if="access == 'doctor' || access == 'clinic'" name="report" type="file" style="display:none;" value="" ref="report" @change="upload">
             <a :href="`consultations/` + consultation.id + `/room`" class="u-card__action r-link button">Перейти к консультации</a>
        </div>
    </div>
</template>

<script>
    import dayjs from "dayjs";
    import utc from 'dayjs/plugin/utc';
    import api from "../../../admin/api/api";
    import CardDoctor from "./Card/CardDoctor";
    import Card from "./Card/Card";
    import CardMeta from "./Card/CardMeta";

    dayjs.extend(utc);

    export default {
        name: "Consultation",
        components: {CardMeta, Card, CardDoctor},
        props: {
            consultation: {
                type: Object,
                required: true
            },
            access: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                report: this.consultation.report,
                onlineType: window.laravel.appointmentsTypes.online,
                clinicType: window.laravel.appointmentsTypes.clinic,
                anonymImg: window.laravel.anonymImg,
                dateNow: dayjs(new Date().toLocaleString("en-US", {timeZone: window.laravel.userTimeZone ? window.laravel.userTimeZone : Intl.DateTimeFormat().resolvedOptions().timeZone})),
            }
        },
        computed: {
            startAt() {
                return dayjs.createFromTimezone(this.consultation.start_at, window.laravel.userTimeZone ? window.laravel.userTimeZone : Intl.DateTimeFormat().resolvedOptions().timeZone).format('D MMM YYYY HH:mm');
            },
            dateAfter() {
                return dayjs(this.dateNow).isAfter(dayjs.createFromTimezone(this.consultation.start_at, window.laravel.userTimeZone ? window.laravel.userTimeZone : Intl.DateTimeFormat().resolvedOptions().timeZone).add(30, 'minute'));
            }
        },
        methods: {
            upload($event) {
                if (!$event.target.files.length) {
                    return false;
                }

                let formData = new FormData();

                formData.append('file', $event.target.files[0]);

                api.post('/report/' + this.consultation.id + '/upload', formData,  {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.report = response.data
                }).catch(error => {
                    alert(error);
                });
            }
        }
    }
</script>
